import { render, staticRenderFns } from "./shampooing-and-conditioning-procedures.vue?vue&type=template&id=b4239110&"
import script from "./shampooing-and-conditioning-procedures.vue?vue&type=script&lang=js&"
export * from "./shampooing-and-conditioning-procedures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports